import React, { useMemo, useState } from "react";
import theme from "theme";
import { Theme, Image, Box, Text, Section, Link, Input, Button, List } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { Override, SocialMedia } from "@quarkly/components";
import * as Components from "components";
import { MdMenu } from "react-icons/md";

import axios from 'axios';

import { useLoginState } from './userStateContext';

import localFavicon from '../resources/Icons/logo_32x32.ico';
import SOMALogo from '../resources/Logos/Logo.jpeg';

export default (() => {

	const [journalJsonData, setJournalJsonData] = useState({
		journalName: '',
		journalTopic: '',
		emailId: '',
		phNo: '',
		coverPageUpload: null,
		articleUpload: null,
		photoUpload: ([]),
	});

	const [coverPageUploaded, setcoverPageUploaded] = useState(false);
	const [articleUploaded, setarticleUploaded] = useState(false);
	const [photoUploaded, setphotoUploaded] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	// const [journalName, setJournalName] = useState('');
	// const [journalTopic, setJournalTopic] = useState('');
	// const [emailId, setEmailId] = useState('');
	// const [phNo, setPhNo] = useState('');
	// const [coverPageUpload, setCoverPageUpload] = useState(null);
	// const [articleUpload, setArticleUpload] = useState(null);
	// const [photoUpload, setPhotoUpload] = useState([]);

	const { loginState, updateLoginState } = useLoginState(false);

	const handleJsonDataChange = (event) => {
		// const newValue = event.target.value; // Get the new value from the input
		// const eventTrigger = event.target.name;

		// switch (eventTrigger) {
		// 	case 'journalName':
		// 	    setJournalJsonData({ ...journalJsonData, journalName: newValue });
		// 		break;
		// 	case 'journalTopic':
		// 	    setJournalJsonData({ ...journalJsonData, journalTopic: newValue });
		// 	    break;
		// 	case 'emailId':
		// 	    setJournalJsonData({ ...journalJsonData, emailId: newValue });
		// 	    break;
		// 	case 'phNo':
		// 	    setJournalJsonData({ ...journalJsonData, phNo: newValue });
		// 	    break;
		// }
	};

	const handleFileUpload = (event) => {
		// console.log("\n###### File Upload Triggered ######\n");
		// const eventTrigger = event.target.name;
		// const selectedFile = Array.from(event.target.files[0]);

		// if ( eventTrigger == "coverPageUpload" ) {
		// 	console.log("\ncoverPageUpload\n");
		// 	setJournalJsonData({ ...journalJsonData, coverPageUpload: selectedFile });
		// 	setcoverPageUploaded(true);
		// 	console.log(journalJsonData.coverPageUpload);
		// }
		// else {
		// 	console.log("\narticleUpload\n");
		// 	setJournalJsonData({ ...journalJsonData, articleUpload: selectedFile });
		// 	setarticleUploaded(true);
		// 	console.log(journalJsonData.articleUpload);
		// }
	}	

	const handleImageUpload = (event) => {
		// const eventTrigger = event.target.name;
		// const selectedFiles = Array.from(event.target.files);

		// // Ensure the selected files are valid image types
		// const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/tiff'];
		// const validFiles = selectedFiles.filter((file) => allowedFileTypes.includes(file.type));

		// if (validFiles.length > 5) {
		// 	setErrorMessage('You can only upload up to 5 image files.');
		// } 
		// else {
		// 	setErrorMessage('');
		// 	setJournalJsonData({ ...journalJsonData, photoUpload: validFiles });
		// 	setphotoUploaded(true);
		// }
	}

	function jsonToFormData() {

		// console.log("\n### Json data : ###\n");
		// console.log(JSON.stringify(journalJsonData));

		// const formData = new FormData();
		// for (const key in journalJsonData) {
		// 	if (journalJsonData.hasOwnProperty(key)) {
		// 		formData.append(key, journalJsonData[key]);
		// 	}
		// }
		// return formData;
	}

	const sendMail = async () => {
		// try {
		// 	const emailAdd = "NJ.SOMA.develop@gmail.com;editorinchiefsoma@gmail.com";
		// 	const mailSubject = "Article Submission - NJSOMA service";
		// 	const formattedData = Object.keys(journalJsonData)
		// 		.map(key => `${key}: ${journalJsonData[key]}`)
		// 		.join('\n')

		// 	console.log(formattedData);
		// 	const mailToLink = `mailto:${emailAdd}?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(formattedData)}`;
		// 	window.location.href = mailToLink;
		// } catch (error) {
		// }
	}

	const handleSubmit = async () => {		
		// console.log("Form submission.");
		// console.log(JSON.stringify(journalJsonData));
		// sendMail();

		//const formDataToSend = jsonToFormData();
		//console.log(JSON.stringify(formDataToSend));

		// formDataToSend.append('journalJsonData', JSON.stringify(journalJsonData));
		// console.log(formDataToSend.journalJsonData);
		// sendEmail(formDataToSend);

		// try {
		// 	// Send the data to the server
		// 	console.log("SendingEMail forward to server");
		// 	const response = await axios.post('./php_server/submitArticle.php', journalJsonData, {
		// 		//headers: { 'Content-Type': 'multipart/form-data' },
		// 		method: 'POST',
		// 	});

		// 	if (response.ok) {
		// 		const result = await response.text();
		// 		console.log("Article Submitted successfully");
		// 		console.log(result);
		// 	} else {
		// 		console.error('Article submission request failed. Please try again');
		// 		const result = await response.text();
		// 		console.log(result);
		// 	}

		// 	// Show a success message
		// 	alert('Article submission Data uploaded successfully!');
		// } catch (error) {
		// 	console.error('Error:', error);
		// 	console.log("Error in Article submission request detected");
		// 	alert('An error occurred while tring Article submission . Please try again later.');
		// }
	}

	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"journal-submission"} />
		<Helmet>
			<title>
				Journal
			</title>
			<meta name={"description"} content={"It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."} />
			<meta property={"og:title"} content={"journal-submission"} />
			<meta property={"og:description"} content={"It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."} />
			<link rel={"shortcut icon"} href={localFavicon} type={"image/x-icon"} />
		</Helmet>
		<Section>
			<Override slot="SectionContent" />
			<Box
				min-width="100px"
				min-height="100px"
				order="0"
				align-self="stretch"
				display="flex"
			>
				<Box display="flex" align-items="center" sm-flex-wrap="wrap">
					<Link
						opacity="0.6"
						text-decoration-line="initial"
						text-align="left"
						hover-text-decoration-line="underline"
						font="--base"
						color="--dark"
						white-space="nowrap"
						href="https://www.societyofmedicalanatomists.com/"
						margin="1px 0px 0px 10px"
					>
						<Image
							src={SOMALogo}
							display="block"
							max-height="150px"
							max-width="150px"
							srcSet=""
							sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
						/>
					</Link>
				</Box>
				<Box min-width="100px" min-height="100px" align-self="center">
					<Text margin="0px 0 24px 0" text-align="center" font="--headline2" md-font="--headline3">
						National Journal of Society of Medical Anatomists
					</Text>
				</Box>
				<Box min-width="100px" min-height="100px">
					<Input
						display="block"
						placeholder-color="LightGray"
						background="white"
						id="loginUser"
						className="LoginUser"
						defaultValue="User ID :"
						disabled
						opacity={0}/*{loginState ? 1 : 0}*/
					/>
					<Button opacity={0}/*{loginState ? 0 : 1}*/ id="loginRegBtn" className="LoginRegBtn" onClick={() => {
							//window.location.href='/loginPages/landingPage';	
						}}
					>
						Login
					</Button>
					<Button opacity={0}/*{loginState ? 1 : 0}*/ id="logoutRegBtn" className="LogoutRegBtn" onClick={() => {
							//window.location.href='/loginPages/landingPage';	
						}}
					>
						Logout
					</Button>
				</Box>
			</Box>
		</Section>
		<Section padding="16px 0 16px 0" quarkly-title="Header" align-items="center" justify-content="center">
			<Override
				slot="SectionContent"
				md-margin="0px 16px 0px 16px"
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				md-grid-template-columns="repeat(2, 1fr)"
				margin="0px 32px 0px 32px"
				width="100%"
			/>
			<Box min-width="100px" min-height="100px" />
			<Box>
				<Components.BurgerMenu md-display="flex" md-align-items="center" md-justify-content="flex-end">
					<Override slot="icon-open" md-position="fixed" md-top="18px" md-right="18px" />
					<Override
						slot="menu"
						md-top={0}
						md-width="100%"
						justify-content="center"
						lg-transition="transform 400ms ease 0s"
						md-position="fixed"
						display="flex"
						md-left={0}
						lg-transform="translateY(0px) translateX(0px)"
						md-height="100%"
						padding="0px 0 0px 0"
						align-items="center"
					>
						<Override
							slot="item"
							md-padding="16px 40px 16px 40px"
							display="inline-block"
							text-transform="uppercase"
							text-align="center"
							padding="8px 20px 8px 20px"
						/>
						<Override slot="item-404" lg-display="none" display="none" />
						<Override slot="item-index" lg-display="none" display="none" />
						<Override
							slot="link"
							md-hover-opacity="1"
							md-active-opacity="1"
							md-color="--dark"
							font="--base"
							text-transform="initial"
							md-font="16px/24px sans-serif"
							text-decoration-line="initial"
							color="--dark"
							transition="opacity .15s ease 0s"
							letter-spacing="0.5px"
							md-opacity=".5"
							md-transition="opacity .15s ease 0s"
							opacity=".5"
							hover-opacity="1"
						/>
						<Override
							slot="link-active"
							md-opacity="1"
							md-cursor="default"
							opacity="1"
							color="--primary"
							cursor="default"
						/>
					</Override>
					<Override slot="icon,icon-close" category="md" icon={MdMenu} />
					<Override
						slot="icon"
						category="md"
						icon={MdMenu}
						size="36px"
						md-right="0px"
						md-position="relative"
					/>
					<Override
						slot="menu-open"
						md-justify-content="center"
						md-top={0}
						md-bottom={0}
						md-display="flex"
						md-flex-direction="column"
						md-align-items="center"
					/>
				</Components.BurgerMenu>
			</Box>
		</Section>
		<Section>
            <Override slot="SectionContent" pointer-events="auto" />
            <Box
                align-items="center"
                display="flex"
                justify-content="center"
                flex-direction="column"
                margin="0px 0px 32px 0px"
                width="100%"
            >
                <a
                    href="https://review.jow.medknow.com/NJSOMA"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: 'inline-block',
                        padding: '10px 20px',
                        backgroundColor: '#6200ea',
                        color: '#fff',
                        textDecoration: 'none',
                        borderRadius: '4px',
                        textAlign: 'center',
                        cursor: 'pointer',
                    }}
                >
                    Go to Article Submission Page
                </a>
            </Box>
			
		</Section>
		<Section />
		<Section
			margin="0 0 0 0"
			padding="16px 0 16px 0"
			box-sizing="border-box"
			quarkly-title="Footer"
			justify-content="center"
		>
			<Override
				slot="SectionContent"
				min-width="auto"
				width="100%"
				margin="0px 32px 0px 32px"
				md-margin="0px 16px 0px 16px"
			/>
			<Box
				width="100%"
				grid-template-columns="repeat(2, 1fr)"
				sm-grid-gap="16px"
				display="grid"
				grid-gap="32px"
			>
				<Box display="flex" align-items="center" sm-flex-wrap="wrap">
					<Image
						width="28px"
						height="28px"
						src={SOMALogo}
						srcSet=""
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
					<Link
						opacity="0.6"
						text-decoration-line="initial"
						text-align="left"
						hover-text-decoration-line="underline"
						font="--base"
						color="--dark"
						white-space="nowrap"
						href="https://www.societyofmedicalanatomists.com/"
						margin="1px 0px 0px 10px"
					>
						SOMA
					</Link>
				</Box>
				<SocialMedia facebook="https://www.facebook.com/NJSOMA/" twitter="https://twitter.com/njsoma" youtube="https://www.youtube.com/channel/UCK5bXs2L0bbSMQ82BQ3hIkw" justify-content="flex-end">
					<Override slot="link" background="none" border-radius="50%" />
					<Override slot="icon" color="--dark" />
				</SocialMedia>
			</Box>
		</Section>
	</Theme>;
});